<template>
    <div>
        <b-collapse id="collapseSearchParcel" v-model="search.collapseSearch">
            <div class="card-body card-bg-color">
                <div class="row">
                    <div class="col-12 col-md-12 col-lg-12 col-xl-4">
                        <b-form-group label="วันที่ขนส่งแจ้งปัญหา (วันเริ่มต้น - วันสุดท้าย)" class="mb-0" >
                            <date-range-picker
                                class="w-100"
                                :opens="'center'"
                                @start-selection="logEvent('startSelection', $event)"
                                @finish-selection="logEvent('finishSelection', $event)"
                                :min-date="minDate"
                                :max-date="maxDate"
                                :singleDatePicker="false"
                                :appendToBody="true"
                                :ranges="false"
                                :closeOnEsc="false"
                                :autoApply="true"
                                :locale-data="{ format: 'dd/mm/yyyy' }"
                                v-model="search.date"
                            >
                            </date-range-picker>  
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-12 col-lg-12 col-xl-8 mb-3"> 
                        <div class="row">
                            <b-form-group
                                label="ข้อมูลต้นทาง"
                                label-for="search-sender"
                                class="mb-0 col-6"
                            >
                                <b-form-input 
                                    id="search-sender" 
                                    type="text"  
                                    placeholder="ค้นหาด้วยชื่อ, เบอร์โทร"
                                    v-model="search.sender"
                                ></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="ข้อมูลปลายทาง"
                                label-for="search-recipient"
                                class="mb-0 col-6"
                            >
                                <b-form-input 
                                    id="search-recipient" 
                                    type="text" 
                                    placeholder="ค้นหาด้วยชื่อ, เบอร์โทร"
                                    v-model="search.dest"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <hr class="d-block d-md-none d-lg-none mb-0" />
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>

import moment from 'moment'
import { dateLimitRanges } from "@/plugins/datePicker.js"

export default {
    props:{
        search: Object
    },
     data(){
        return{    
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
        }
    },
    methods:{
        logEvent( event , date ){
            const { minDate , maxDate } =  dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
    }
}
</script>